/** Roles the platform supports. This build ships the student surface only. */
export enum UserRole {
  Student = 'student',
  Teacher = 'teacher',
  Admin = 'admin',
}

/** Landing route for each role, used after login and by the role guard. */
export const ROLE_HOME: Record<UserRole, string> = {
  [UserRole.Student]: '/student/dashboard',
  [UserRole.Teacher]: '/teacher/dashboard',
  [UserRole.Admin]: '/admin/dashboard',
};
